import React, { createContext, useContext, useState } from 'react';

type TipContextType = {
  billValue: number | null;
  setBillValue: (value: number | null) => void;
  tipValue: number | null;
  setTipValue: (value: number | null) => void;
  tipAmount: number;
  totalAmount: number;
};

const TipContext = createContext<TipContextType | undefined>(undefined);

// eslint-disable-next-line react/function-component-definition
export const TipProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [billValue, setBillValue] = useState<number | null>(0);
  const [tipValue, setTipValue] = useState<number | null>(17);

  const tipAmount = billValue && tipValue ? (billValue * tipValue) / 100 : 0;
  const totalAmount = billValue ? billValue + tipAmount : 0;

  return (
    <TipContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        billValue,
        setBillValue,
        tipValue,
        setTipValue,
        tipAmount,
        totalAmount,
      }}
    >
      {children}
    </TipContext.Provider>
  );
};

export const useTipContext = () => {
  const context = useContext(TipContext);

  if (!context) {
    throw new Error('useTipContext must be used within a TipProvider');
  }

  return context;
};
